/// <reference path="../../../../proposals/api/proposalsApi.d.ts" />
import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query'
import { getDocuments, getImages, getPackage } from 'proposals/api/documentServiceApiClient'

export type VendorDecisionAttachment = Pick<DocumentReturnType, 'id' | 'originalName' | 'url'>

export const useVendorDecisionAttachmentsApi = (
  contextToken: string | undefined
): UseQueryResult<VendorDecisionAttachment[], unknown> => {
  return useQuery({
    queryKey: ['vendor-decision-attachments', contextToken],
    queryFn: async () => {
      const token = contextToken as string
      const [documents, images] = await Promise.all([getDocuments(token), getImages(token)])
      return [...documents, ...images]
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    enabled: !!contextToken
  })
}

export const useVendorDecisionAttachmentsArchive = (
  contextToken: string | undefined,
  fileName: string
): { downloadAll: () => void; isDownloading: boolean } => {
  const { mutate, isPending } = useMutation({
    mutationFn: () => getPackage(contextToken as string),
    onSuccess: (urlToBlob) => {
      const link = document.createElement('a')
      link.href = urlToBlob
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      link.parentNode?.removeChild(link)
    }
  })

  return { downloadAll: () => mutate(), isDownloading: isPending }
}
